import type { ExtraAppValue } from "../../../services/api/instances/extraAppApi/types";
import { StorageObject } from "../../../services/api/instances/storageApi/types/object_types";
import { multiUserApi } from "../../../shared/utils/multiUserFunctions";
import { TProfileData } from "../../Modals/ProfileModal/types";

export const getAppUri = (
  uri: string | undefined,
  withToken: boolean,
  profile?: TProfileData | null,
  isProfileFilled?: boolean,
) => {
  if (!uri) return undefined;
  const token = multiUserApi.getUserKey("access_token");
  const url = new URL(uri, window.location.origin);
  if (withToken && token) {
    url.searchParams.set("user_token", token);
  }

  if (profile && isProfileFilled) {
    url.searchParams.set("username", profile.username);
    url.searchParams.set("usertable", String(profile.usertable));
  }

  return url.toString();
};

export const updateAppInTree = (
  items: StorageObject<ExtraAppValue>[],
  updatedApp: StorageObject<ExtraAppValue>,
): StorageObject<ExtraAppValue>[] => {
  return items.map((obj) => {
    if (obj.id === updatedApp.id) {
      return updatedApp;
    }

    if (obj.children?.length) {
      return {
        ...obj,
        children: updateAppInTree(obj.children, updatedApp),
      };
    }

    return obj;
  });
};

export const isValidUrl = (urlString: string): boolean => {
  try {
    const parsedUrl = new URL(urlString);
    return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
  } catch (error) {
    return false;
  }
};
